export default __webpack_public_path__ + "static/media/teee.38aa82c7.svg";